//mechanisms that interact with our internal ad service

var CTA = function(){

    var _init = function(){

    }

    return {
        init: function(){
            _init();
        }
    }

}();